import IrosPointCreationPage from "./IrosPointCreationPage";

export default IrosPointCreationPage 